import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { observer } from "mobx-react";
import { CircularProgress } from "@material-ui/core";

function ProfileEditorDialog({ store }) {
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");

  React.useEffect(() => {
    if (!store.user) {
      return;
    }
    setFirstName(store.user.first_name);
    setLastName(store.user.last_name);
  }, [store.user]);

  const handleSave = (e) => {
    store.saveUserDetails(firstName, lastName);
    e.preventDefault();
  };

  if (!store.user) {
    return null;
  }

  return (
    <Dialog open={store.isProfileEditorOpen}>
      <form onSubmit={handleSave}>
        <DialogTitle id="form-dialog-title">Profile</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter your details to continue.
          </DialogContentText>
          <TextField
            autoFocus
            hintText="Email"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="First Name"
            fullWidth
            defaultValue={store.user.first_name ?? ""}
          />
          <TextField
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Last Name"
            fullWidth
            defaultValue={store.user.last_name ?? ""}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            disabled={store.isProfileUpdating}
          >
            {store.isProfileUpdating ? <CircularProgress size={14} /> : "Save"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default observer(ProfileEditorDialog);
